import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useSelector } from "react-redux";
import GenderTable from "./GenderTable";
import AgeTable from "./AgeTable";
import CitizenDistributionTable from "../Reports/UniqueCitizenDistribution";

const BASE_URL = "https://api-project360-insights.haqdarshak.com";

const CombinedDashboard = () => {

  const pid = useSelector((state) => state.user.projectId);

  const [states, setStates] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);

  const [activeTab, setActiveTab] = useState("br");

  const [citizenData, setCitizenData] = useState(null);
  const [caseData, setCaseData] = useState(null);

  useEffect(() => {

    fetch(`${BASE_URL}/kpi/citizen/unique-states/?pid=${pid}`)
      .then(res => res.json())
      .then(data => {
        setStates(data.unique_states.map(s => ({ value: s, label: s })));
      });

  }, [pid]);

  useEffect(() => {

    const fetchData = async () => {

      let citizenUrl = `${BASE_URL}/kpi/citizen/gender-${activeTab}/?pid=${pid}`;
      let caseUrl = `${BASE_URL}/kpi/gender-wise/${activeTab}/?pid=${pid}`;

      selectedStates.forEach(s => {
        citizenUrl += `&State=${s.value}`;
        caseUrl += `&State=${s.value}`;
      });

      const [cRes, caseRes] = await Promise.all([
        fetch(citizenUrl),
        fetch(caseUrl)
      ]);

      setCitizenData(await cRes.json());
      setCaseData(await caseRes.json());

    };

    if (pid) fetchData();

  }, [pid, activeTab, selectedStates]);

  return (
    <div className="p-6 max-w-[85vw]">
       <CitizenDistributionTable />
      {/* Tabs */}

      

      <div className="border-2 pb-[2vh] mx-[3vw] mb-[2vh] w-full border-black-100 rounded-lg mt-8">
        <div className="p-4 border-b">
        <h2 className="text-xl font-bold  text-pink-800">
          Age and Gender Distribution
        </h2>
       </div>

      <div className="flex gap-4 mb-6 ml-[32vw] mt-4 ">

       

        {["open", "ds", "br"].map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 rounded 
              ${activeTab === tab ? "bg-pink-200 text-pink-800" : "bg-gray-200"}`}
          >
            {tab.toUpperCase()}
          </button>
        ))}

      </div>

      {/* Filters */}
      <div className="w-72 mb-2 mx-[3vw]">
        <Select
          options={states}
          isMulti
          placeholder="Select State"
          value={selectedStates}
          onChange={setSelectedStates}
        />
      </div>

      {/* ✅ Combined Table */}
      <GenderTable
        citizenData={citizenData}
        caseData={caseData}
      />

      <AgeTable
        type={activeTab}
        states={selectedStates}
        />
        </div>

    </div>
  );
};

export default CombinedDashboard;